/**
 * Layout shell for the redesigned Manage Returns area: loads portal/UI settings and renders child routes via Outlet.
 * Back navigation targets the new list path (APP_PATHS.RETURNS_NEW) so it pairs with manage-returns-new routes.
 */
import { observer } from "mobx-react";
import { Outlet, useNavigate } from "react-router-dom";
import BasePageLayout from "../../components/layouts/base-page-layout/base-page-layout";
import { useEffect } from "react";
import currentPortalStore from "../../stores/current-portal-store";
import uiSettingsStore from "../../stores/ui-settings-store";
import useDashboardTranslation from "../../dashboard-translation/hooks/dashboard-translation-hook";
import { APP_PATHS } from "../../constants/app-paths";

const ManageReturnsPageNew: React.FC = observer(() => {
    const { getTranslation } = useDashboardTranslation();
    useEffect(() => {
        currentPortalStore.load();
        uiSettingsStore.load();
    }, []);

    const navigate = useNavigate();

    const onBackButtonClick = () => {
        navigate(APP_PATHS.RETURNS_NEW);
    };

    return (
        <BasePageLayout
            title={getTranslation("MANAGE_RETURNS", "dashboard-returns-page") + '- NEW PAGE'}
            backButtonCallback={onBackButtonClick}
        >
            <Outlet />
        </BasePageLayout>
    );
});

export default ManageReturnsPageNew;
